import {db} from '../firebase';
import fsClient from '../data/firestoreClient';
const keys=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
const storageKey='loop_business_campaign_v1';
export function businessCampaign(search='') {
  const params=new URLSearchParams(search), clean={};
  keys.forEach(key=>{const value=params.get(key);if(value)clean[key]=value.slice(0,120);});
  try {
    if(Object.keys(clean).length){sessionStorage.setItem(storageKey,JSON.stringify({values:clean,at:Date.now()}));return clean;}
    const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');
    return saved && Date.now()-saved.at<86400000 ? saved.values : {};
  } catch{return clean;}
}
export function businessSignupTarget(search='') {
  const params=new URLSearchParams(businessCampaign(search));
  return '/new-business'+(params.toString()?'?'+params.toString():'');
}
export async function trackBusinessFunnel(type,{search='',businessId=''}={}) {
  try {
    if(!db)return;
    const campaign=businessCampaign(search), now=new Date().toISOString();
    const sessionKey='loop_business_funnel_session';
    let sessionId=sessionStorage.getItem(sessionKey);
    if(!sessionId){sessionId=globalThis.crypto?.randomUUID?.() || `visit_${Date.now()}_${Math.random().toString(36).slice(2)}`;sessionStorage.setItem(sessionKey,sessionId);}
    const payload={type,eventType:type,source:campaign.utm_source||'direct',sourceArea:'business_landing',sessionId,createdAt:now,occurredAt:now};
    keys.forEach(key=>{if(campaign[key])payload[key.replace(/_([a-z])/g,(_,c)=>c.toUpperCase())]=campaign[key];});
    if(businessId)payload.businessId=businessId;
    await fsClient.addDocToCollectionPath('platformEvents',payload,{db});
  } catch { /* Analytics never blocks registration. */ }
}
